// Central content + brand config for The Brook at Khanna's Farm

export const BRAND = {
  name: "The Brook",
  full: "The Brook at Khanna's Farm",
  location: "Karjat, Maharashtra",
  tagline: "A timeless escape, rooted in nature, crafted with heart.",
  manifesto: "Rooted in heritage · Inspired by nature · Made for memories",
  whatsapp: "919769711463",
  whatsappMessage:
    "Hi! I'd love to reserve a stay at The Brook at Khanna's Farm. Could you share availability?",
  phoneDisplay: "+91 97697 11463",
  phoneDisplay2: "+91 93238 07382",
  email: "bookthebrook@gmail.com",
  address: "The Brook at Khanna's Farm, Karjat, Maharashtra, India",
  instagram: "https://instagram.com/thebrookatkhannasfarm",
  instagramHandle: "@thebrookatkhannasfarm",
};

export const whatsappHref = (msg) =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(
    msg || BRAND.whatsappMessage,
  )}`;

export const ASSETS = {
  headerLogoWhite:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/vp081gu1_B_Logo-45.webp",
  footerCrest:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/xkqq9ob5_B_Logo-04.webp",
  monogramGreen:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_9964583a-13da-4bcb-b9a0-7e3d2e5ea888/artifacts/xdf1qgel_B_Logo-25.webp",
  monogramGold:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_9964583a-13da-4bcb-b9a0-7e3d2e5ea888/artifacts/ncozibnw_B_Logo-26.webp",

  // Hero
  hero: "https://customer-assets-39nsmqrw.emergentagent.net/job_9964583a-13da-4bcb-b9a0-7e3d2e5ea888/artifacts/bm00zk2z_Banner%203.webp",

  // The River (main portrait) + a feature shot
  river:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/in88f4wz_DSC_0175.webp",

  // The Space — real interiors
  bedroomMorocco:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/hvyz2onu_Morocco%20Room%20-%204.webp",
  roomInterior:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/harqftyw_Room%20Interior.webp",
  spaceDetails:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/9u5b23jo_Details.webp",

  // The Table — real food
  foodThali:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/q1i9t6rt_DSC_0225.webp",
  foodDosa:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/c4cwf8bt_DSC_1814.webp",

  // Events & Corporate
  eventSinger:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/uaw8j524_Copy%20of%20JJ46.jpg",
  eventTable:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/d5c4r4pw_JJ33.jpg",

  // Gallery-only (do not repeat elsewhere)
  gKarBanjaFlowers:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/yntvqghm_DSC_0915.webp",
  gBabyPotatoes:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/u5azgbrt_DSC_0129.webp",
  gRoomSetup:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/xy2529m1_Room%20Setup%202.webp",
  gKidReading:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/2tdh8xzb_instagram_Bu3C3DHnCb2.jpg",
  gPathGardener:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/4gsu7k43_DSC_0078.webp",
  gRiverMomMe:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/uoj04dtr_River%20mom%20and%20me%202.webp",
  gTeaSetup:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/5ja1j9q8_Tea%20Setup.webp",
  gNightMoroccoRoom:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/22g1q2h4_Night%20Morocoo%20Room.webp",
  gCycling:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/b1vf9oh1_Cycling%20-%205.webp",
  gGardenServing:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/elwz5jm7_Garden%20-%20Fruit%20Serving.webp",
  gPetDog:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/ppx0wt6k_instagram_C_b15ukouHD.jpg",
  gEventTable:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/d5c4r4pw_JJ33.jpg",
  gDetails:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/9u5b23jo_Details.webp",
  gPuppyWalk:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/6mvxhlq1_DSC_0155.webp",
  gLantern:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/qubect4n_DSC_0183.webp",
  gLotus:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/obd0josn_DSC_0250.webp",
  gRiversidePerch:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/3t6t73s5_DSC_0963.webp",
  gBarbecue:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/04kllwyb_DSC_0668.webp",

  // Instagram (display-only, latest attachments)
  igBua:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/t68yyx9l_Bua%20-%20Jackfruit%202.webp",
  igLights:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/v4mq4dpf_Lights%20Aesthetic.webp",
  igDsc0139:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/5idpbwhe_DSC_0139.webp",
  igGardenRiverRapid:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/0a12xyyl_Garden%20River%20Rapid.webp",
  igGardenSide:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/eiv160oq_Garden%20Side.webp",
  igKitchenGarlic:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/snngc56i_DSC_0183%20%281%29.webp",
};

export const CHAPTERS = [
  {
    id: "story",
    label: "Our Story",
    kicker: "For you, me & us",
    paragraphs: [
      "Imagine breaking away from the dull and the mundane — into a world where birds chirp, butterflies drift past colourful blossoms, a river meanders carefree all along, and the night sky shimmers with a thousand stars.",
      "A hideaway so serene and pure, where moments with family and loved ones become lasting memories. A place truly meant to be 'for you, me & us.'",
      "The Brook sits in the scenic countryside of Karjat — built amidst lush grounds, overlooking the Western Ghats on one end while touching a perennial river on the other.",
      "It was built by us, the Khannas, as a private family getaway. Over time, it became too beautiful to keep to ourselves.",
    ],
  },
];

export const RIVER = {
  label: "The River",
  headline: "Some places have a pool.\nWe have a river.",
  lines: [
    "Life at The Brook begins at the water's edge.",
    "A river runs right through the property — not past it, not beside it, but through it.",
    "You wake up to its sound before you see it. By mid-morning it's where you find the children. By evening it's where everyone ends up.",
    "It flows through every season. Always moving. Always cold enough to make you catch your breath when you step in.",
  ],
};

export const FOOD = {
  label: "The Table",
  headline: "This is what we feed you.\nThis is how we love you.",
  lines: [
    "Food is at the heart of everything we do at The Brook.",
    "Made from scratch, by our cook, in our kitchen — the way it has been since the day we opened.",
    "Warm, generous, unhurried. The kind of food that reminds you of home, even if you've never tasted it before.",
    "Breakfast on the lawn as the mist lifts. Lunch in the shade. Dinner with the brook murmuring beside you.",
  ],
};

export const SPACE = {
  label: "The Space",
  headline: "One home.\nEvery corner with a story to tell.",
  lines: [
    "Spacious and fully-furnished — large living rooms, a gaming area, open terraces, and bedrooms that feel nothing like a hotel room. High ceilings, generous windows, and views into the trees.",
    "What distinguishes our home are the carefully placed art and artefacts. Paintings, sculptures and knick-knacks brought back from travels within the country and abroad. A Persian carpet here. A Moroccan-inspired corner there. Objects that have crossed oceans to find their place on these walls.",
    "These are not decorations. They give the house its soul.",
  ],
};

export const NAV_LINKS = [
  { label: "Our Story", href: "#story" },
  { label: "The River", href: "#river" },
  { label: "The Space", href: "#space" },
  { label: "The Table", href: "#food" },
  { label: "Amenities", href: "#amenities" },
  { label: "Events", href: "#events" },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact Us", href: "#contact" },
];

export const AMENITIES = [
  { icon: "Trophy", title: "Badminton Court" },
  { icon: "Gamepad2", title: "Game Room", note: "Board & card games" },
  { icon: "CircleDot", title: "Pool Table" },
  { icon: "Palmtree", title: "Riverside Hammocks" },
  { icon: "Home", title: "Shaded Gazebos" },
  { icon: "Trees", title: "Open Lawns" },
  { icon: "Waves", title: "Inflatable Pool for Kids", note: "On demand" },
  { icon: "Sailboat", title: "River Rafting", note: "On Demand" },
  { icon: "Mountain", title: "Trekking in the Hills" },
  { icon: "Bike", title: "Cycling", note: "On demand" },
  { icon: "Flame", title: "Barbecue", note: "On demand" },
  { icon: "Star", title: "Stargazing" },
];

export const REVIEW_PHOTOS = [
  {
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/hh2ve3oc_dd3b533d-4846-4847-9edc-fa207dfc09b1.jpg",
    alt: "The whole gang, together at the farm",
  },
  {
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/2kcb1bte_656241857_18571820740028550_5373851921337105185_n.jpg",
    alt: "A splash in the river with the whole gang",
  },
  {
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/ex6gqeja_instagram_Bukyqs_HQZN.jpg",
    alt: "Little explorers on the river rocks",
  },
  {
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/8nl2exgv_instagram_BRdVO6lh-Sn.jpg",
    alt: "Ankle-deep in the river, arms wide open",
  },
  {
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/sdjesk6y_651444854_18398134339199806_5299472987972292181_n.jpg",
    alt: "Nights under fairy lights",
  },
  {
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/9z5v3yv5_instagram_BREHUdlhF7m.jpg",
    alt: "A wedding on the lawn",
  },
  {
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/gpt1nhus_instagram_By2P8f4lG6r.jpg",
    alt: "A birthday to remember",
  },
  {
    src: "https://customer-assets-7cd3h4nn.emergentagent.net/job_brook-khanna/artifacts/lussu3s9_instagram_BPmPErGh7mV.jpg",
    alt: "Kayaking mornings with new friends",
  },
];

export const REVIEWS = [
  {
    quote:
      "I didn't say 'eat', because you don't eat at The Brook, you hog! The food, cooked to your specification, is wholesome, finger licking tasty and keeps coming until you burp!",
    name: "Bharti S Pradhan",
    role: "Author",
  },
  {
    quote:
      "If you are fed up with your routine and want to unwind, the address is 'The Brook at Khanna's Farm'. The jovial welcome by the hosts sets the tone. The gentle sound of the river can ease any mind.",
    name: "Vishal Vasudev",
    role: "Entrepreneur",
  },
  {
    quote:
      "One warning — don't eat before visiting The Brook! They literally fill you up with mouth watering meals.",
    name: "Bhavuk Dheer",
    role: "Filmmaker",
  },
  {
    quote:
      "Came for the villa, stayed for the amazing stories of Swapna Ma'am and Raman Sir. Also be prepared for Savita Tai to keep feeding you till you say stop! We weren't treated as guests, but family.",
    name: "Vishal Shah",
    role: "Doctor",
  },
  {
    quote:
      "The farm is so tastefully decorated! Every inch of the house is filled with character, a photographer's dream. And the flowing water is the cherry on top.",
    name: "Hugo Loupy",
    role: "Photographer",
  },
  {
    quote:
      "You are glued to the place the moment you step foot into it. Truly magical.",
    name: "Lata Pant",
    role: "Lawyer",
  },
];

export const GALLERY_IMAGES = [
  { src: ASSETS.gCycling, alt: "A slow ride down the palm walk", ratio: "landscape" },
  { src: ASSETS.gGardenServing, alt: "Fruit served under the pink umbrella", ratio: "landscape" },
  { src: ASSETS.gEventTable, alt: "A candlelit dinner setup on the lawn", ratio: "landscape" },
  { src: ASSETS.gDetails, alt: "Art & artefacts brought back from travels", ratio: "portrait" },
  { src: ASSETS.gKidReading, alt: "A quiet afternoon by the river", ratio: "landscape" },
  { src: ASSETS.gLantern, alt: "A terracotta lantern under the tiles", ratio: "portrait" },
  { src: ASSETS.gRiverMomMe, alt: "Mother and son by the river", ratio: "landscape" },
  { src: ASSETS.gNightMoroccoRoom, alt: "The Moroccan room after dark", ratio: "landscape" },
  { src: ASSETS.gPuppyWalk, alt: "Morning walks with new friends", ratio: "landscape" },
  { src: ASSETS.gRoomSetup, alt: "A room with a view", ratio: "portrait" },
  { src: ASSETS.gTeaSetup, alt: "Chai on the veranda", ratio: "landscape" },
  { src: ASSETS.gRiversidePerch, alt: "A quiet perch above the water", ratio: "landscape" },
  { src: ASSETS.gLotus, alt: "A lotus in bloom on the lily pond", ratio: "landscape" },
  { src: ASSETS.gPathGardener, alt: "The palm walk, tended each morning", ratio: "portrait" },
];

export const TABLE_MORE_IMAGES = [
  { src: ASSETS.gBabyPotatoes, alt: "Baby potatoes on a banana leaf" },
  { src: ASSETS.gBarbecue, alt: "Kebabs on the grill, well after dark" },
  { src: ASSETS.gKarBanjaFlowers, alt: "Sweets and flowers, straight from our kitchen" },
];
